import React from 'react';
import PropTypes from 'prop-types';
import { EdmundsLogo } from 'site-modules/shared/components/edmunds-logo/edmunds-logo';
import { applyTemplateParams } from 'site-modules/shared/components/lead-form/utils/utils';
import { HeaderConfigPropTypes } from 'site-modules/shared/components/lead-form/lead-form-prop-types/lead-form-prop-types';

import './photoflipper-vdp-thank-you-header.scss';

export function PhotoflipperVdpThankYouHeader({ config: { showLogo, text } = {}, templateParams = [] }) {
  return (
    <div className="photoflipper-vdp-thank-you-header mb-1_5">
      <div className="header-text mb-0_75 d-flex flex-row align-items-center">
        {showLogo && <EdmundsLogo className="me-1" inline inlineLogoHeight={34} />}
        <span className="size-24 text-primary fw-bold">{applyTemplateParams(templateParams, text)}</span>
      </div>
    </div>
  );
}

PhotoflipperVdpThankYouHeader.propTypes = {
  config: HeaderConfigPropTypes.header,
  templateParams: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};
